"use client";

import { Monitor, Search, MapPin, ArrowRight, Plus } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function WebsiteDesignServices() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: gridRef,
    isVisible: gridVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const services = [{
    id: "01",
    title: "Website Design",
    description: "High-performance, custom-built websites designed to convert visitors into loyal customers for your growing business.",
    icon: Monitor,
    href: "/WebsiteDesignPage"
  }, {
    id: "02",
    title: "SEO Strategy",
    description: "Data-driven search engine optimization to increase your organic visibility and dominate your industry search results.",
    icon: Search,
    href: "/SeoPage"
  }, {
    id: "03",
    title: "Local SEO",
    description: "Expert management of your Google Business Profile to solve listing issues and capture local market share.",
    icon: MapPin,
    href: "/LocalSeoPage"
  }];
  return;
}